"use client";
import { useEffect } from "react";

interface ClientIdHOCPropTypes {
    clientId: string;
    children: React.ReactNode;
}
const ClientIdHOC = (props: ClientIdHOCPropTypes) => {
    const { children, clientId } = props;

    const handleSetClientId = async () => {
        await fetch("/api/set-client-id", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ clientId }),
        });
    };
    useEffect(() => {
        if (clientId) {
            handleSetClientId();
        }
    }, [clientId]);

    return <>{children}</>;
};

export default ClientIdHOC;
